import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { ClubListOrdering, useClubListQuery } from '../queries';
import { useAuthentication } from '~/hooks/useAuthentication';
import { useFilterForm } from '~/hooks/useFilterForm';
import { ClubListFilters } from './club-list-filters';
import { Button } from '~/components/Button/Button';
import { ClubListTable } from './club-list-table';
import { Link } from '~/components/Link/Link';
import { querySchema } from './query-schema';
import { Fragment } from 'react/jsx-runtime';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);
  const { can } = useAuthentication();

  const { data, isLoading } = useClubListQuery({
    is_active: values.state !== 'ALL' ? true : undefined,
    ordering: values.ordering as ClubListOrdering,
    district__id: values.district_id,
    page_size: values.pageSize,
    page: values.pageIndex,
    search: values.search,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Föreningsregister" />

        {can('create-club') && (
          <Link to="create">
            <Button type="button">Skapa ny</Button>
          </Link>
        )}
      </PageLayout.Header>

      <PageLayout.Section>
        <ClubListFilters />
        <ClubListTable clubs={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
